__turbopack_context__.v({
  "captionFlexItems": "-q5euG_captionFlexItems",
  "carousal-img-container": "-q5euG_carousal-img-container",
  "circle-blur-btn": "-q5euG_circle-blur-btn",
  "content": "-q5euG_content",
  "element-img": "-q5euG_element-img",
  "embla": "-q5euG_embla",
  "embla__container": "-q5euG_embla__container",
  "embla__next": "-q5euG_embla__next",
  "embla__prev": "-q5euG_embla__prev",
  "embla__slide": "-q5euG_embla__slide",
  "root": "-q5euG_root",
  "shimmer": "-q5euG_shimmer",
  "video-container": "-q5euG_video-container",
});
